// extracted by mini-css-extract-plugin
module.exports = {"Button":"CustomButton_Button__218s5","Success":"CustomButton_Success___fU4a","Danger":"CustomButton_Danger__9BsgD"};